import { useAppSelector } from '@/store/hooks';
import { getUser } from '@/store/slices/user/selectors';
import type { IWatermarkElement } from '@/types/watermarks.types';
import TextEl from './text';

const EmailEl = (el: IWatermarkElement) => {
  const email = useAppSelector(getUser)?.email ?? '';
  return <TextEl {...el} settings={{ ...el.settings, text: { ...el.settings.text, value: email } }} />;
};

export default EmailEl;
